export const GET_USER_AUTH = 'GET_USER_AUTH'
export const GET_USER_AUTH_SUCCESS = 'GET_USER_AUTH_SUCCESS'
export const GET_USER_AUTH_ERROR = 'GET_USER_AUTH_ERROR'
export const SET_STORE_LOGO = 'SET_STORE_LOGO'

export const SET_LOCATION_INFO = 'SET_LOCATION_INFO'
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA'
